import { Box, CircularProgress, IconButton, TableCell } from '@mui/material'
import React, { useState } from 'react'
import { GetApp as GetAppIcon, Visibility } from '@mui/icons-material'
import { useAuthContext } from '../../../../hooks/useAuthContext'
import { fileServices } from '../../../../services/fileServices'
import LongMenu from '../../../../pages/DataEntryPage/Fields/LongMenu'
import FileViewer from './FileViewer'
import { useResponsiveTypography } from '../../../../utility/responsiveTypography'

const TableCellFile = ({ color, isHidden, value, width }) => {
  const { user } = useAuthContext()
  const [isLoading, setIsLoading] = useState(false)
  const [isViewerOpen, setIsViewerOpen] = useState(false)
  const { previewText } = useResponsiveTypography()

  const downloadFile = async (fileName) => {
    setIsLoading(true)
    await fileServices.downloadFile(user, fileName)
    setIsLoading(false)
  }

  const options = [
    {
      label: 'Preview',
      icon: (
        <IconButton size="small">
          <Visibility />
        </IconButton>
      ),
      onClick: () => setIsViewerOpen(true),
    },
    {
      label: 'Download',
      icon: (
        <IconButton size="small">
          {isLoading ? <CircularProgress color="info" size={'25px'} /> : <GetAppIcon />}
        </IconButton>
      ),
      onClick: () => downloadFile(value),
    },
  ]

  return (
    <TableCell
      sx={{
        width: width + 'rem',
        color: color,
        display: isHidden ? 'none' : '',
        fontSize: previewText,
      }}
    >
      {value && (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {value}

          <LongMenu options={options} />

          <FileViewer
            open={isViewerOpen}
            onClose={() => setIsViewerOpen(false)}
            fileKey={value}
            user={user}
            onDownload={() => downloadFile(value)}
          />
        </Box>
      )}
    </TableCell>
  )
}

export default TableCellFile
